<div *appRole="['Movimientos.Crear']">


  <!-- Botón principal -->
  <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">
    Nuevo
    <mat-icon>add</mat-icon>
  </button>
  <!-- Menú desplegable -->
  <mat-menu #menu="matMenu">
    <button mat-menu-item
      [disabled]="contratoDetailDto == undefined ? false : contratoDetailDto.estadoContrato.id == estadosContrato.Finalizado "
      color="primary" (click)="openDialogCreateMovimiento(false)">
      <mat-icon>add</mat-icon>
      Movimiento
    </button>
    <button mat-menu-item
      [disabled]=" contratoDetailDto == undefined ? false : contratoDetailDto.estadoContrato.id == estadosContrato.Finalizado "
      color="primary" (click)="openDialogNuevoMovimientoCaja()">
      <mat-icon>add</mat-icon>
      Movimiento Caja
    </button>
    <button mat-menu-item
      [disabled]="contratoDetailDto == undefined ? false : contratoDetailDto.estadoContrato.id == estadosContrato.Finalizado "
      color="primary" (click)="openDialogCreateMovimiento(true)">
      <mat-icon>add</mat-icon>
      Movimiento Propiedad
    </button>
  </mat-menu>
</div>

<br>
<br>
<mat-card *appRole="['Movimientos.Listar']">
  <ngx-spinner [zIndex]="100" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
    [fullScreen]="false">
  </ngx-spinner>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
            <!-- Filtros base: 4 campos que en escritorio ocupan 1/4 cada uno,
                 en tablet 1/2 y en celular el ancho completo. -->
            <div class="row filtros-row">
              <div class="col-12 col-md-6 col-lg-3">
                <mat-form-field class="full-width">
                  <mat-label>Rango Fecha Movimiento</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [disabled]="true" formControlName="FechaDesde" placeholder="Desde">
                    <input matEndDate [disabled]="true" formControlName="FechaHasta" placeholder="Hasta">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <mat-form-field class="full-width">
                  <mat-label>Rangos Rapidos (FM)</mat-label>
                  <mat-select placeholder="Seleccione opcion" formControlName="RangoFecha"
                    (selectionChange)="selectRangoFecha($event)">
                    <mat-option [value]="fecha.id"
                      *ngFor="let fecha of lstRangoFecha ;let i=index;trackBy:trackByItems">
                      {{fecha.descripcion | titlecase}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <mat-form-field class="full-width">
                  <mat-label>Nro. Contrato</mat-label>
                  <input type="number" formControlName="NumeroContrato" matInput>
                  <mat-icon matSuffix>gavel</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <mat-form-field class="full-width">
                  <mat-label>Rango Fecha Pago</mat-label>
                  <mat-date-range-input [rangePicker]="pickerFechaPago">
                    <input matStartDate [disabled]="true" formControlName="FechaPagoDesde" placeholder="Desde">
                    <input matEndDate [disabled]="true" formControlName="FechaPagoHasta" placeholder="Hasta">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="pickerFechaPago"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerFechaPago disabled="false"></mat-date-range-picker>
                </mat-form-field>
              </div>
            </div>

            <!-- Filtros avanzados: mismo esquema de 4 columnas para que queden
                 alineados con la fila de arriba. -->
            <div class="row filtros-row" *ngIf="checkedFiltroAvanzado">
              <div class="col-12 col-md-6 col-lg-3">
                <ngx-spinner [zIndex]=100 name="spBusquedaTiposMovimientos" bdColor="rgba(255,255,255,0.8)"
                  size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <app-buscar-tipo-movimiento [tiposMovimiento]="lstTiposMovimientos" etiqueta="Tipos Movimientos"
                  [idTipoMovimiento]="idTipoMovimientoSeleccionado"
                  (eventTipoMovimiento)="selectTipoMovimiento($event)">
                </app-buscar-tipo-movimiento>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <app-buscar-propiedad (eventEntity)="selectPropiedad($event)"></app-buscar-propiedad>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <app-buscar-persona-propietaria (eventEntity)="selectPropietario($event)" [showDocumento]="false">
                </app-buscar-persona-propietaria>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <app-buscar-persona-inquilino (eventEntity)="selectInquilino($event)">
                </app-buscar-persona-inquilino>
              </div>
            </div>

            <div class="row">
              <div class="col-12 acciones-filtro">
                <button mat-stroked-button color="primary" (click)="buscarMovimientos()">
                  <mat-icon>filter_alt</mat-icon>
                  Filtrar
                </button>
                <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
                  Filtros Avanzados
                </mat-slide-toggle>
                <button mat-stroked-button color="primary" (click)="clearFilter()">
                  <mat-icon>clear_all</mat-icon>
                  Limpiar
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </form>

  <div class="row" [hidden]=!data>
    <div class="col-lg-2">
      <mat-form-field class="example-full-width">
        <mat-label>Buscar</mat-label>
        <input type="search" matInput (keyup)="applyFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort [hidden]=!data (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8">

    <!-- Tipo Movimiento Column -->
    <ng-container matColumnDef="tipoMovimientoDescripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por Tipo de Movimiento">
        <span>Movimiento</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span class="celda-con-icono">
          <mat-icon class="icono-tipo" [class.resta]="element.tipoMovimiento.resta"
            [matTooltip]="element.tipoMovimientoDescripcion">
            {{ element.tipoMovimiento?.icono ? element.tipoMovimiento.icono : 'swap_horiz' }}
          </mat-icon>
          <span>{{element.tipoMovimiento.resta == true ?
            element.tipoMovimientoDescripcion + ' (-)' : element.tipoMovimientoDescripcion + ' (+)' | titlecase}}</span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="contratoDescripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por Contrato">
        <span>Contrato</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/contratos',element.contratoId]" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Ver"><span>{{element.contratoDescripcion | titlecase}}</span></a>
      </td>
    </ng-container>

    <ng-container matColumnDef="inquilinoDescripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por Inquilino">
        <span>Inquilino</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{element.inquilinoDescripcion | titlecase}}</span>

      </td>
    </ng-container>

    <ng-container matColumnDef="propietarioDescripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por Propietario">

        <span>Propietario</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{element.propietarioDescripcion | titlecase}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="periodo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>Periodo</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.periodoMes">
          {{element.periodoMes +"/"+ element.periodoAnio+"-"+element.periodo}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaEmision">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>Fecha Emisión</span>
      </th>
      <td mat-cell *matCellDef="let element"> <span>{{element.fechaEmision | date:('dd/MM/yyyy')}}</span> </td>
    </ng-container>

    <ng-container matColumnDef="fechaPago">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>Fecha Pago</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.anulado">{{element.fechaPago | date:('dd/MM/yyyy')}}</span>
        <span *ngIf="element.anulado"><strong>Anulado</strong></span>
      </td>
    </ng-container>

    <ng-container matColumnDef="importe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>Importe</span>
      </th>
      <td mat-cell *matCellDef="let element"> <span>{{element.importe | currency}} </span></td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>Detalle</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{element.descripcion}}</span>
        <!-- <mat-icon *ngIf="element.descripcion" color="primary" [matTooltip]="element.descripcion">info</mat-icon> -->
      </td>
    </ng-container>

    <ng-container matColumnDef="accion">
      <th mat-header-cell *matHeaderCellDef> Acción</th>
      <td mat-cell *matCellDef="let element" class="action-link">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button *appRole="['Movimientos.Ver']" mat-menu-item (click)="openDialogViewMovimiento(element.id)">
            <mat-icon>visibility</mat-icon>
            Ver
          </button>
          <div *appRole="['Movimientos.Modificar']">
            <button mat-menu-item *ngIf="element.fechaPago == null && element.anulado == false"
              (click)="openDialogUpdateMovimiento(element.id,'Editar')">
              <mat-icon>edit</mat-icon>
              Editar
            </button>
          </div>

          <div *appRole="['Movimientos.Eliminar']">
            <button *ngIf="element.fechaPago == null && element.anulado == false" mat-menu-item
              (click)="openDialogUpdateMovimientoEliminar(element.id,'Eliminar')">
              <mat-icon>delete</mat-icon>
              Eliminar
            </button>
          </div>

        </mat-menu>
      </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>


  <app-sin-datos *ngIf="dataSource.data.length == 0"></app-sin-datos>
  <mat-paginator showFirstLastButtons class="paginator" [hidden]=!data [pageSize]="20"
    [pageSizeOptions]="[5, 10, 20,50,100,200]">
  </mat-paginator>
</mat-card>
